/**
 * `/suspended` — shown when a suspended account attempts to sign in via
 * magic-link. The verify route 302s here rather than rendering a generic
 * error so the user gets a clear, actionable message.
 */

import { Link } from 'react-router-dom';
import { AuthShell } from '../components/layout/AuthShell';

export function SuspendedPage() {
  return (
    <AuthShell>
      <div className="auth-card">
        <div className="auth-eyebrow">
          <span className="num">!!</span> · Account suspended
        </div>
        <h1 className="auth-title">
          Your account is <em>suspended.</em>
        </h1>
        <p className="auth-sub">
          You can't sign in right now. If you think this is a mistake, fill out the <Link to="https://forms.gle/GsmUBjwswycJofrE7">contact form</Link>.
        </p>
      </div>
    </AuthShell>
  );
}
